// extracted by mini-css-extract-plugin
module.exports = {"help":"CatalogHelp_help__ZRfM_","icon":"CatalogHelp_icon__0Cd_H","copy":"CatalogHelp_copy__le5r3","actions":"CatalogHelp_actions__OogZg"};